export function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1)
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4()
}

export function strToBool(str) {
    return str && str.toLowerCase() === "true"
}

export function mergeFieldsRight(obj1, obj2) {
    const fieldsToMerge = Object.keys(obj2)
    return fieldsToMerge.reduce((acc, c) => {
        const mergedValue = obj1[c] ? [].concat(obj1[c], obj2[c]) : obj2[c]
        return {
            [c]: mergedValue,
            ...acc,
        }
    }, {})
}

export function arrayify(arrOrObj) {
    return (Array.isArray(arrOrObj))
        ? arrOrObj
        : [arrOrObj]
}

// one line versions of mergeFieldsRight:
// const merge = (obj1, obj2) => Object.keys(obj2).reduce((acc, c) => ({ ...acc, [c]: obj1[c] ? [].concat(obj1[c], obj2[c]) : obj2[c] }), {})

// check if a time entries input is an array. If it is, turn it into a map object
export function sanitizeEntries(entries) {
    return Array.isArray(entries)
        ? entries.reduce(
            (acc, entry) => {
                return { ...acc, [entry.id]: entry }
            }, {})
        : entries
}

export const isSafari = () => {
    const ua = window.navigator.userAgent
    const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
    const webkit = !!ua.match(/WebKit/i)
    return iOS && webkit && !ua.match(/CriOS/i)
}

export const getKeyCode = key => {
    switch (key) {
        case 13:
            return "KEY_ENTER"
        default:
            return ""
    }
}

const sortById = (i, j) => {
    return i.id < j.id ? -1 : i.id > j.id ? 1 : 0
}

export const arraysWithObjectIdEqual = (a, b) => {
    return arraysEqualFields(a, b, ["id"])
}

export const arraysEqualFields = (a, b, fields) => {
    if (a === b) {
        return true
    }
    if (a.length != b.length) {
        return false
    }
    const aSorted = a.sort(sortById)
    const bSorted = b.sort(sortById)
    const misMatchedItem = aSorted.find((aItem, i) => {
        const bItem = bSorted[i]
        const misMatchedField = fields.find(field => {
            return aItem[field] !== bItem[field]
        })

        return misMatchedField
    })

    return misMatchedItem === undefined
}


// WEBPACK FOOTER //
// ./src/util/random_utils.js